import React from 'react';
import styled from 'styled-components'

export const Section = (props) => {
    return(
        <Outer background={props.background}>
            <Inner direction={props.direction}>{props.children}</Inner>
        </Outer>);
};

const Outer = styled.div`
  width:100vw;
  height:auto;
  background: ${props => props.background ? props.background : null};
  text-align:center;
`
const Inner = styled.div`
    width:100%;
    display:flex;
    flex-wrap:wrap;
    flex-direction: ${props => props.direction ? props.direction : "row"};
    justify-content: center;
    margin:0 auto;
    max-width:1000px;
`